import { PAY_PERMISSIONS, TabItem } from '@vyce/core/src/types';

export const PAYROLL_TABS: TabItem[] = [
  {
    label: 'Dashboard',
    link: '/payroll/dashboard',
  },
  {
    label: 'Timesheets',
    link: '/payroll/timesheets',
    permission: PAY_PERMISSIONS.READ_TIMESHEET,
  },
  {
    label: 'Payruns',
    link: '/payroll/payruns',
    permission: PAY_PERMISSIONS.CAN_READ_PAY_RUN,
  },
  {
    label: 'Reports',
    link: '/payroll/reports',
    permission: PAY_PERMISSIONS.READ_CIS300,
  },
  {
    label: 'Users',
    link: '/payroll/users',
  },
  {
    label: 'Settings',
    link: '/payroll/settings',
    permission: [
      PAY_PERMISSIONS.READ_PAY_SCHEDULES,
      PAY_PERMISSIONS.MANAGE_BANK_DETAILS,
      PAY_PERMISSIONS.MANAGE_HMRC_SETTINGS,
    ],
  },
];

export const OUTSOURCED_PAYROLL_TABS = PAYROLL_TABS.filter(
  tab =>
    tab.label !== 'Payruns' &&
    tab.label !== 'Reports' &&
    tab.label !== 'Timesheets' &&
    tab.label !== 'Dashboard' &&
    tab.label !== 'Settings'
);
